import { Base } from "ui/Scripts/source/framework/base";
import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { EnumHelper, RecordEducationScopeUnit } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { IRecordEditItemQualification } from "./recordEditItemQualification";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";

export interface IRecordEditItemFurtherEducation extends IEditItem {
    furtherEducationId: string;
    furtherEducationCode: string;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    scopeUnitStr: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    comment: string;
    activeState: number;
    modifyUser: IModifyUser;
    isQualification: boolean;
    qualificationValid: boolean;

    getTitle(): string;
    getIsArchived(): boolean;
    setFurtherEducationCode2(furtherEducationGroups: IRecordFurtherEducationGroupNode[]);
    setScopeUnitStr();
    setQaulificationValidity(recordQualifications: IRecordEditItemQualification[]);
}

export class RecordEditItemFurtherEducation extends EditItem implements IRecordEditItemFurtherEducation {
    furtherEducationId: string;
    furtherEducationCode: string;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    scopeUnitStr: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    comment: string;
    activeState: number;
    modifyUser: ModifyUser;
    isQualification: boolean;
    qualificationValid: boolean;

    constructor();
    constructor(obj: IRecordEditItemFurtherEducation);
    constructor(obj?: any) {
        super(obj);
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.furtherEducationCode = obj && obj.furtherEducationCode || "";
        this.scope = obj && obj.scope || 0;
        this.scopeUnit = obj && obj.scopeUnit || RecordEducationScopeUnit.Hour;
        this.scopeUnitStr = obj && obj.scopeUnitStr || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.isQualification = obj && obj.isQualification || false;
        this.qualificationValid = obj && obj.qualificationValid || false;
    }

    getTitle(): string {
        return this.furtherEducationCode + ", " + Base.utcTimeToDateStr(this.startDate);
    }

    getIsArchived(): boolean {
        return this.activeState < 0.5;
    }

    setFurtherEducationCode(furtherEducations: IIdTitleNode[]) {
        this.furtherEducationCode = "";
        if (!this.furtherEducationId) return;
        const furtherEducation = IdTitleNode.getById(furtherEducations, this.furtherEducationId);
        if (!furtherEducation) return;
        this.furtherEducationCode = furtherEducation.title;
    }

    setFurtherEducationCode2(furtherEducationGroups: IRecordFurtherEducationGroupNode[]) {
        this.furtherEducationCode = "";
        if (!this.furtherEducationId) return;
        const furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(furtherEducationGroups, this.furtherEducationId);
        if (!furtherEducation) return;
        this.furtherEducationCode = furtherEducation.code;
    }

    setScopeUnitStr() {
        this.scopeUnitStr = EnumHelper.RecordEducationScopeUnitToStr(this.scopeUnit);
    }

    static setFurtherEducationCodes(items: IRecordEditItemFurtherEducation[], furtherEducationGroups: IRecordFurtherEducationGroupNode[]) {
        for (const item of items) {
            item.setFurtherEducationCode2(furtherEducationGroups);
            item.setScopeUnitStr();
        }
    }

    setQaulificationValidity(recordQualifications: IRecordEditItemQualification[]) {
        this.isQualification = false;
        this.qualificationValid = false;
        //#1 Qualification is related to FurtherEducation
        const furtherEducationQualifications = recordQualifications.filter(i => !!i.furtherEducationId);
        for (const furtherEducationQualification of furtherEducationQualifications) {
            const recordQualification = furtherEducationQualification.userFurtherEducations.find(i => i.id === this.id);
            if (!recordQualification) continue;
            this.isQualification = true;
            this.qualificationValid = recordQualification.valid;
            return;
        }
        //#2 Qualification is related to FurtherEducationGroug
        // const furtherEducationGroupQualifications = recordQualifications.filter(i => !!i.furtherEducationGroupId);
        // for (const furtherEducationGroupQualification of furtherEducationGroupQualifications) {
        //     const recordQualification = furtherEducationGroupQualification.userFurtherEducations.find(i => i.id === this.id);
        //     if (!recordQualification) continue;
        //     this.isQualification = true;
        //     this.qualificationValid = furtherEducationGroupQualification.valid;
        //     return;
        // }
    }

    static setQaulificationsValidity(items: IRecordEditItemFurtherEducation[], recordQualifications: IRecordEditItemQualification[]) {
        for (const item of items) {
            item.setQaulificationValidity(recordQualifications);
        }
    }
    
    static sortRecordEditItemFurtherEducations(items: IRecordEditItemFurtherEducation[], column: string, asc: boolean): IRecordEditItemFurtherEducation[] {
        if (!items && items.length < 2) return items;
        if (column === "scope") {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.scope, b.scope)); });
        } else if (column === "scopeUnit") {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.scopeUnitStr, b.scopeUnitStr)); });
        } else if (column === "startDate") {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.startDate, b.startDate)); });
        } else if (column === "endDate") {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.endDate, b.endDate)); });
        } else if (column === "validityEndDate") {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        } else if (column === "activeState") {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.activeState, b.activeState)); });
        } else if (column === "comment") {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        } else {
            return items.sort((a: IRecordEditItemFurtherEducation, b: IRecordEditItemFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.furtherEducationCode, b.furtherEducationCode)); });
        }
    }
}

export class RecordEditItemFurtherEducationSave extends EditItem {
    furtherEducationId: string;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    comment: string;
    activeState: number;

    constructor();
    constructor(obj: IRecordEditItemFurtherEducation);
    constructor(obj?: any) {
        super(obj);
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.scope = obj && obj.scope || 0;
        this.scopeUnit = obj && obj.scopeUnit || RecordEducationScopeUnit.Hour;
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
    }
}